import React, { Component } from "react";
import { Link, withRouter, Redirect } from "react-router-dom";
import { Modal, ModalClose, ModalBody } from "react-modal-bootstrap";
import ImageGallery from "react-image-gallery";
import RightMenu from "../RightMenu";
import RightIconMenu from "../RightIconMenu";
import calendar_icon from "../../../assets/images/calendar_icon.png";
import DatePicker from "react-datepicker";
import print_icon2 from "../../../assets/images/printer.svg";
import moment from "moment";
import AudioPlayer from "react-custom-audio-player";
import "./index.css";
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton
} from 'react-share';
import {
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon
} from 'react-share';

class View_type_22 extends Component {
    constructor(props) {
        super(props);
        moment.locale("pl");
        var data = Array.isArray(props.data)
            ? props.data[0]
            : props.data;
        this.state = {
            data: data,
            r_menu: data.right_menu
                ? data.right_menu
                : [],
            rightIconMenu: data.right_icon_menu
                ? data.right_icon_menu
                : [],
            rightMenu: data.right_menu
                ? data.right_menu
                : [],
            title: data.title
                ? data.title
                : "",
            tabs: data.tabs
                ? data.tabs
                : [],
            content: data.content
                ? data.content
                : [],
            read_more: data.read_more
                ? data.read_more
                : [],
            list: data.list
                ? data.list
                : [],
            gallery: data.gallery
                ? data.gallery
                : [],
            calendar: data.calendar
                ? data.calendar
                : null,
            apla_color: data.place_color
                ? data.place_color
                : [],
            open: false,
            isOpen: false,
            showPlayButton: true,
            showGalleryPlayButton: false,
            showFullscreenButton: true,
            showGalleryFullscreenButton: false,
            currentImage: 0,
            player: [],
            redirectUrl: null,
            startDate: null,
            smallCalendarVisible: false,
            audioTrack: {
                id: false,
                status: false,
                prevTrack: false
            }
        };

        if (this.state.data.text) {
            let sentence = this.state.data.text;
            let sentenceX = sentence.replace(/<[^>]*>?/gm, '').substring(0, 200);
            let jsonItem = JSON.stringify({ title: this.state.data.title, image: this.state.data.image_background, text: sentenceX });
            let jsonItem64 = btoa(unescape(encodeURIComponent(jsonItem)))
            let readyJson = jsonItem64;
            sessionStorage.setItem('socialUrl', readyJson);
        }
    }

    getLanguageFromPath = () => {
        const pathname = (this.props.location && this.props.location.pathname) || window.location.pathname || '/pl';
        const segments = pathname.split('/').filter(Boolean);
        return segments[0] || 'pl';
    }

    isCategoriesPage = () => {
        const pathname = (this.props.location && this.props.location.pathname) || window.location.pathname || '';
        return pathname.includes('/koncerty/kategorie');
    }

    getResolvedItemUrl = item => {
        if (item && item.url) {
            return item.url;
        }

        if (this.isCategoriesPage() && item && item.id) {
            return `/${this.getLanguageFromPath()}/koncerty/archiwum/${item.id}`;
        }

        return null;
    }

    navigateToUrl = url => {
        if (!url) {
            return;
        }

        if (/^https?:\/\//i.test(url)) {
            window.location.href = url;
            return;
        }

        this.props.history.push(url);
    }

    createMarkup(item) {
        return { __html: item };
    }
    onClickHandler = index => {
        this.setState({
            isOpen: !this.state.isOpen,
            currentImage: index
        }, () => {
        });
    };
    hideModal = () => {
        this.setState({ isOpen: false });
    };

    printDoc = () => {
        // CREATE NEW DIV
        const item = document.createElement("div");
        const date = new Date;
        const now = date.toLocaleString();
        const link = window.location.href;
        const created = document.getElementById("print-only-params");

        // ADD CONTENT TO DIV
        item.innerText = `${now} ${link}`;

        // ADD WHOLE ITEM TO BODY - VISIBLE ONLY IN PRINT MODE
        if (created === null) {
            item.id = "print-only-params";
            document.getElementsByTagName("body")[0].insertAdjacentElement('afterbegin', item);
        }
        window.print();
    }

    changeDate = date => {
        let pickDate = date.format("YYYY-MM-DD");
        this.setState({
            redirectUrl: this.state.calendar.filter((elem, i) => {
                let score = elem.date == pickDate;
                return score;
            })
        }, () => {
            if (this.state.redirectUrl[0]) {
                this.props.history.replace(this.state.redirectUrl[0].url);
            }
        });
    };

    openCalendar = () => {
        this.setState({
            smallCalendarVisible: !this.state.smallCalendarVisible
        })
    }

    _renderImages = item => {
        return (<div className="images image-gallery-image">
            <div className="images image-wrapper">
                <img src={item.img} alt="" className="images multimedia_image" />
                <span className="images image-gallery-description">{item.desc}</span>
                {
                    item.descEN
                        ? (<span className="images image-gallery-description desc-ang">{item.desc}</span>)
                        : null
                }
            </div>
        </div>);
    };

    _renderThumbImages = item => {
        return (
            <img 
                src={item.img} 
                alt={item.desc || item.original || "Gallery thumbnail"} 
                className="image-gallery-thumbnail-image" 
            />
        );
    };

    displayAudioTrack = (event, arg) => {
        event.currentTarget.childNodes[1].style.display = 'block';
        this.setState({
            audioTrack: {
                id: arg
            }
        })
    }

    // For every image in .vt22-title-text class add eventListener with customLightbox function
    componentDidMount() {
        document.querySelectorAll(".vt22-title-text img").forEach(e => e.addEventListener("click", this.customLightbox.bind(null, e)))
    }

    // Create customLightbox
    customLightbox(e) {
        // Create image
        const imageSrc = e.getAttribute("src");
        const image = document.createElement("img");
        image.setAttribute("src", imageSrc);

        // Create gallery and add image to it
        const customGallery = document.createElement("div");
        customGallery.classList.add("custom-lightbox");
        customGallery.appendChild(image);
        document.body.appendChild(customGallery);

        // Remove customLightbox
        customGallery.addEventListener("click", function (f) { f.currentTarget.remove() });
    }

    render() {
        let calendar = null
        if (this.state.calendar) {
            calendar = (<DatePicker dateFormatCalendar="MMMM" style={{
                height: "200%!important"
            }} inline="inline" calendarClassName="vt4 vt22-calendar" onChange={this.changeDate} highlightDates={this.state.calendar.map(elem => {
                return moment.utc(elem.date);
            })} />);
        }
        if (this.state.data.title && this.state.data.image_background && this.state.data.text) {
            var ogUrl = document.createElement('meta');
            var ogTitle = document.createElement('meta');
            var ogImg = document.createElement('meta');
            var ogDesc = document.createElement('meta');
            ogUrl.setAttribute('property', 'og:url');
            ogTitle.setAttribute('property', 'og:title');
            ogImg.setAttribute('property', 'og:image');
            ogUrl.content = document.location;
            ogTitle.content = this.state.data.title;
            ogImg.content = this.state.data.image_background;
            document.getElementsByTagName('head')[0].appendChild(ogUrl);
            document.getElementsByTagName('head')[0].appendChild(ogTitle);
            document.getElementsByTagName('head')[0].appendChild(ogImg);
        }
        let articleWithImgAndDesc = null;
        let print_icon = null;
        let image_gallery = null;
        let borderStyle = null;

        if (this.state.data.list.length < 1) {
            borderStyle = {
                border: "none"
            };
        }
        if (this.state.data.icon_print = true) {
            print_icon = (
                <div className="vt22-print-wrapper">
                    <button
                        aria-label="print"
                        id="print-btn"
                        onClick={this.printDoc}
                        style={{ backgroundImage: `url(${print_icon2})` }}
                    ></button>
                </div>
            )
        }
        if (this.state.data.gallery) {
            image_gallery = (<div className="vt22__gallery-boxes row" style={borderStyle}>
                {
                    this.state.data.gallery.map((elem, index) => {
                        if (this.state.data.gallery.length % 2 === 0) {
                            return (<div className="vt22__gallery-box vt22__gallery-box--6 col-md-6 col-sm-12" key={index} style={{
                                backgroundImage: `url('${elem.img}')`
                            }} />);
                        } else {
                            return (<div className="vt22__gallery-box col-md-3 col-sm-12" key={index} style={{
                                backgroundImage: `url('${elem.img}')`
                            }} />);
                        }
                    })
                }
            </div>);
        }
        if (this.state.data.gallery && this.state.data.gallery.length > 0 && this.state.data.gallery[0].hasOwnProperty("light_box")) {
            image_gallery = (<div className="vt22__gallery-boxes row gallery-ench" style={borderStyle}>
                {
                    this.state.data.gallery.slice(0, 3).map((elem, index) => {
                        if (this.state.data.gallery.length % 2 === 0 && this.state.data.gallery.length == 2) {
                            return (<div onClick={this.onClickHandler.bind(this, index)} className="vt22__gallery-box vt22__gallery-box-50  col-md-6 col-sm-12" key={index} style={{
                                backgroundImage: `url('${elem.img}')`,
                                cursor: "pointer"
                            }} />);
                        }
                        if (this.state.data.gallery.length % 2 === 0) {
                            return (<div onClick={this.onClickHandler.bind(this, index)} className="vt22__gallery-box col-md-6 col-sm-12" key={index} style={{
                                backgroundImage: `url('${elem.img}')`,
                                cursor: "pointer"
                            }} />);
                        } else {
                            return (<div onClick={this.onClickHandler.bind(this, index)} className="vt22__gallery-box vt22__gallery-box--light_box-1 col-md-4 col-sm-12" key={index} style={{
                                backgroundImage: `url('${elem.img}')`,
                                cursor: "pointer"
                            }}></div>);
                        }
                    })
                }
                <Modal isOpen={this.state.isOpen} onRequestHide={this.hideModal}>
                    <button type="button" className="images player_button_close" onClick={this.hideModal}>
                        X
                    </button>
                    <ModalBody>
                        <ImageGallery key={this.state.currentImage} items={this.state.data.gallery} startIndex={this.state.currentImage} slideInterval={2000} showPlayButton={false} showFullscreenButton={false} onImageLoad={this.handleImageLoad} renderItem={this._renderImages} renderThumbInner={this._renderThumbImages} />
                    </ModalBody>
                </Modal>
            </div>);
        }
        if (this.state.data.image_background) {
            articleWithImgAndDesc = (<div className="vt22__wrapper">
                <img className="col-sm-12 vt22__background-img" src={this.state.data.image_background} alt="background image" /> {
                    this.state.data.place_name && (<div className="vt22__img_title" style={{
                        backgroundColor: this.state.data.place_color
                    }}>
                        <p>{this.state.data.article_place ? this.state.data.article_place : this.state.data.place_name}</p>
                    </div>)
                }
            </div>);
        }
        let font = this.state.data.fontColor;
        var _this = this;
        var var1 = this.state.data.title
            ? this.state.data.title
            : "";

        var right_description = this.state.data.right_description;

        var music = this.state.data.tracks
            ? this.state.data.tracks
            : [];
        var quotation = this.state.data.quotation_section
            ? this.state.data.quotation_section
            : [];
        var musicId = 1;
        var url = window.location.href;
        return (<div className="vt1">
            <div className="left vt22__left col-xs-12 col-sm-12 col-md-9 col-lg-9">
                <div className="vt1-title row links_underline">
                    {
                        this.state.calendar && <div className="vt4 icons col-md-12 hidden-lg">
                            <img alt="open calendar button" className="vt4 calendar_icon vt22-calendar_icon" src={calendar_icon} onClick={this.openCalendar} /> {this.state.smallCalendarVisible && (<div className="vt-22 calendar-small">{calendar}</div>)}
                        </div>
                    }
                    <div className="vt22-title-header">
                        <div className="vt22-title-name" dangerouslySetInnerHTML={{
                            __html: var1
                        }} />
                        {print_icon}
                    </div>
                    {articleWithImgAndDesc}

                    {
                        this.state.data.lead && (<div className="vt22-lead" dangerouslySetInnerHTML={{
                            __html: this.state.data.lead
                        }} />)
                    }

                    {
                        this.state.data.text && (<div className="vt22-title-text" dangerouslySetInnerHTML={{
                            __html: this.state.data.text
                        }} />)
                    }

                    {
                        this.state.data.quotation_section && (<div className="vt22-title-quotation-block">
                            <ul>
                                {
                                    this.state.data.quotation_section.map((elem, index) => {

                                        return (<li key={index}>
                                            <div className="quotation-box">
                                                <span>&bdquo;</span>
                                                <p className="text" dangerouslySetInnerHTML={{
                                                    __html: elem.txt
                                                }}></p>
                                                <span>&ldquo;</span>
                                                <div className="signature" dangerouslySetInnerHTML={{
                                                    __html: elem.signature
                                                }}></div>
                                            </div>
                                        </li>);
                                    })
                                }
                            </ul>
                        </div>)
                    }

                    {
                        this.state.data.tracks && (<div className="vt22-title-text vt22-audio-list">
                            <ul>
                                {
                                    this.state.data.tracks.map((elem, index) => {

                                        if (elem.mp3.substring(elem.mp3.length - 4) === '.mp3' || elem.mp3.substring(elem.mp3.length - 4) === '.MP3') {
                                            return (
                                                <li className="vt22-tracks vt22-audio" key={index} onClick={(event) => {
                                                    this.displayAudioTrack(event, index)
                                                }}>
                                                    <div className="vt22-audio-title-text">
                                                        <p>{musicId++}.</p>
                                                        <div className="vt22-title-audio" dangerouslySetInnerHTML={{
                                                            __html: elem.opus
                                                        }}></div>
                                                    </div>

                                                    <span className="audio__wrapper-vt22">
                                                        {
                                                            this.state.audioTrack.id === index
                                                                ? <AudioPlayer autoplay={true} src={elem.mp3} controls={true} loop={true} />
                                                                : null
                                                            // <AudioPlayer src={elem.mp3} controls={true} loop={true} />
                                                        }
                                                    </span>
                                                </li>);
                                        } else if (elem.mp3 === "") {
                                            return (
                                                <li className="vt22-tracks vt22-audio" key={index}>
                                                    <div className="vt22-audio-title-text noneDisplayBefore">
                                                        <p>{musicId++}.</p>
                                                        <div className="vt22-title-audio" dangerouslySetInnerHTML={{ __html: elem.opus }} />
                                                    </div>
                                                </li>
                                            )
                                        } else {
                                            return (
                                                <li className="vt22-tracks vt22-audio" key={index} onClick={(event) => {
                                                    this.displayAudioTrack(event, index)
                                                }}>
                                                    <div className="vt22-audio-title-text">
                                                        <p>{musicId++}.</p>
                                                        <div className="vt22-title-audio" dangerouslySetInnerHTML={{
                                                            __html: elem.opus
                                                        }}></div>
                                                    </div>

                                                    <span className="audio__wrapper-vt22">
                                                        {
                                                            this.state.audioTrack.id === index
                                                                ? <AudioPlayer autoplay={true} src={elem.mp3} controls={true} loop={true} />
                                                                : null
                                                            // <AudioPlayer src={elem.mp3} controls={true} loop={true} />
                                                        }
                                                    </span>
                                                </li>);
                                        }

                                    })
                                }
                            </ul>
                        </div>)
                    }
                    {image_gallery}
                </div>
                <div className="row" style={{
                    display: "flex",
                    flexWrap: "wrap",
                    // marginLeft: "0",
                    // marginRight: "0"
                }}>
                    {
                        this.state.data.list.map(function (object, i) {
                            if (object !== "undefined" && object.hasOwnProperty("img") && !object.hasOwnProperty("text")) {
                                var color = object.title.backgroundColor;
                                var img = object.img;
                                var thumbnail = (<div style={{
                                    flex: 1,
                                    backgroundColor: color,
                                    padding: 10,
                                    color: "white",
                                    position: "absolute",
                                    left: 15,
                                    right: 15
                                }}>
                                    {object.title.text}
                                </div>);
                                return (<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" key={i}>
                                    <div>
                                        {thumbnail}
                                        <img src={img} className="list_image" />
                                    </div>
                                </div>);
                            } else if (object !== "undefined" && !object.hasOwnProperty("img")) {
                                var color = object.title
                                    ? object.title.backgroundColor
                                    : "";
                                var button = null;
                                var img = object.img;
                                var thumbnail = (<div className="middle-thumbnailholder vt22__box" style={{
                                    flex: 1,
                                    color: font,
                                    backgroundImage: `url(${object.image_background})`
                                }}>
                                    <span className="vt22__box--title" style={{
                                        backgroundColor: object.place_color
                                    }}></span>
                                    <p className="vt22__box--text">
                                        {
                                            object.place_name
                                                ? object.place_name
                                                : ""
                                        }
                                    </p>

                                </div>);

                                const resolvedUrl = _this.getResolvedItemUrl(object)

                                if (resolvedUrl) {
                                    button = (<div className="vt22-middle-addelem">
                                        <Link to={resolvedUrl} className="more_button" aria-label="more button">
                                            {" "}
                                        </Link>
                                    </div>);
                                }

                                return (<div className="vt22__articles-box col-xs-12 col-sm-6 vt22__gallery-box--6 col-md-6 col-lg-6" key={i}>
                                    {
                                        resolvedUrl
                                            ? (<div style={{
                                                cursor: "pointer"
                                            }} onClick={() => _this.navigateToUrl(resolvedUrl)}>
                                                {
                                                    i % 2 == 0
                                                        ? (<div className={`middle-postblock vt22__middle-left`} style={{
                                                            fontWeight: "bold"
                                                        }}>
                                                            {object.image_background && (<span>{thumbnail}</span>)}
                                                            <div className="vt22-article-title" dangerouslySetInnerHTML={_this.createMarkup(object.title)} />
                                                            <div className="vt22-article-title" dangerouslySetInnerHTML={_this.createMarkup(object.article_title)} />
                                                            <div className="vt22-article-place" dangerouslySetInnerHTML={_this.createMarkup(object.article_place)} />
                                                            <div className="vt22-start-date" dangerouslySetInnerHTML={_this.createMarkup(object.start_date)} />
                                                            <div className="vt22-start-date" dangerouslySetInnerHTML={_this.createMarkup(object.hour)} />
                                                            <div className="vt22-end-date" dangerouslySetInnerHTML={_this.createMarkup(object.end_date)} />
                                                            <div className="vt22-title-text" dangerouslySetInnerHTML={_this.createMarkup(object.text)} /> {button}
                                                        </div>)
                                                        : (<div className={`middle-postblock vt22__middle-right`} style={{
                                                            fontWeight: "bold"
                                                        }}>
                                                            {object.image_background && (<span>{thumbnail}</span>)}
                                                            <div className="vt22-article-title" dangerouslySetInnerHTML={_this.createMarkup(object.title)} />

                                                            <div className="vt22-article-title" dangerouslySetInnerHTML={_this.createMarkup(object.article_title)} />
                                                            <div className="vt22-article-place" dangerouslySetInnerHTML={_this.createMarkup(object.article_place)} />
                                                            <div className="vt22-start-date" dangerouslySetInnerHTML={_this.createMarkup(object.start_date)} />
                                                            <div className="vt22-start-date" dangerouslySetInnerHTML={_this.createMarkup(object.hour)} />
                                                            <div className="vt22-end-date" dangerouslySetInnerHTML={_this.createMarkup(object.end_date)} />
                                                            <div className="vt22-title-text" dangerouslySetInnerHTML={_this.createMarkup(object.text)} /> {button}
                                                        </div>)
                                                }
                                            </div>)
                                            : (<div>
                                                {
                                                    i % 2 == 0
                                                        ? (<div className={`middle-postblock vt22__middle-left`} style={{
                                                            fontWeight: "bold"
                                                        }}>
                                                            {object.image_background && (<span>{thumbnail}</span>)}
                                                            <p className="vt22 row__title">{object.title}</p>
                                                            <div className={`${object.article_title ? "vt22-article-title" : "vt22 text__content"}`} dangerouslySetInnerHTML={object.article_title ? _this.createMarkup(object.article_title) : _this.createMarkup(object.text)} /> {button}
                                                        </div>)
                                                        : (<div className={`middle-postblock vt22__middle-right`} style={{
                                                            fontWeight: "bold"
                                                        }}>
                                                            {object.image_background && (<span>{thumbnail}</span>)}
                                                            <p className="vt22 row__title">{object.title}</p>
                                                            <div className={`${object.article_title ? "vt22-article-title" : "vt22 text__content"}`} dangerouslySetInnerHTML={object.article_title ? _this.createMarkup(object.article_title) : _this.createMarkup(object.text)} /> {button}
                                                        </div>)
                                                }
                                            </div>)
                                    }
                                </div>);
                            } else if (object !== "undefined") {
                                var color = object.title
                                    ? object.title.backgroundColor
                                    : "";
                                var button = null;
                                var img = object.img;
                                var thumbnail = (<div className="middle-thumbnailholder" style={{
                                    flex: 1,
                                    backgroundColor: color,
                                    color: "white",
                                    position: "absolute",
                                    left: 25,
                                    right: 25,
                                    padding: 10
                                }}>
                                    {object.title.text}
                                </div>);
                                var img = <img src={img} />;

                                if (typeof object.button !== "undefined") {
                                    button = (<div className="vt22-middle-addelem">
                                        <Link to={object.button.link} className="more_button">
                                            {" "}
                                        </Link>
                                    </div>);
                                }

                                return (<div className="col-xs-6 col-sm-6 col-md-6 vt22__gallery-box--6 col-lg-6 text-center" key={i}>
                                    <div className="middle-postblock">
                                        <div>
                                            {thumbnail}
                                            {img}
                                        </div>
                                        <div dangerouslySetInnerHTML={_this.createMarkup(object.text)} /> {button}
                                    </div>
                                </div>);
                            }
                        })
                    }
                </div>
                {
                    this.state.data.list.length == 0 && this.state.data.image_background == undefined || this.state.data.socialIcon == false
                        ? (null)
                        : (<div className="share-section">
                            <FacebookShareButton url={url + "?media=" + sessionStorage.getItem('socialUrl')}>
                                <FacebookIcon size={50} />
                            </FacebookShareButton>

                            <TwitterShareButton url={url + "?media=" + sessionStorage.getItem('socialUrl')}>
                                <TwitterIcon size={50} />
                            </TwitterShareButton>

                            <LinkedinShareButton url={url + "?media=" + sessionStorage.getItem('socialUrl')}>
                                <LinkedinIcon size={50} />
                            </LinkedinShareButton>
                        </div>)
                }

            </div>
            <div className="right col-xs-3 col-sm-3 col-md-3 col-lg-3">
                {
                    this.state.rightMenu.length
                        ? (<RightMenu data={this.state.rightMenu} />)
                        : null
                }
                {this.state.rightIconMenu && <RightIconMenu data={this.state.rightIconMenu} />}
                <div className="vt-22 right_description" dangerouslySetInnerHTML={{
                    __html: right_description
                }} /> {this.state.calendar && (<div className="vt-22 calendar-lg">{calendar}</div>)}

            </div>
        </div>);
    }
}
export default withRouter(View_type_22);



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_22/index.js